import script from "./HeaderArea.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeaderArea.vue?vue&type=script&setup=true&lang=ts"

import "./HeaderArea.vue?vue&type=style&index=0&id=71c5fdc5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71c5fdc5"]])

export default __exports__